import axios from "axios";
import moment from "moment-timezone";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import config from "../../../../Config";
import { color_grey_light, color_grey_ultra_light, color_red_active, color_red_default, color_white } from "../../../../constants/colors";
import { englishLevelsObjectArray } from "../../../../constants/levels";
import { updateStudent } from "../../../../store/StudentSlice";
import { useWindowDimensions } from "../../../../utils";
import { Button } from "../../../controls/Button/Button";
import { OnestBoldSmall, OnestNormalDefault, OnestNormalSmall, OnestSemiBoldSmall } from "../../../styled/TextComponents";
import ModalQuestion from "../../ModalQuestion";
import ModalSimple from "../../ModalSimple";
import { styles } from "./styles";
import { useI18n } from "../../../../i18n/I18nProvider";

export const TextInput = ({
    multiline = false,
    width = "auto",
    height = 50,
    title,
    placeholder = null,
    inputKey,
    defaultValue = null,
    inputBackgroundColor = null,
    onChange,
    value,
    type = "text",
    style = {},
}) => {



    const memoizedOnChange = (e) => {
        if (typeof onChange === "function") {
            onChange(e);
        }
    };


    return (
        <div style={{
            ...styles.infoEditContainer,
            flex: 1,
        }}>
            <OnestSemiBoldSmall>{title}</OnestSemiBoldSmall>
            {multiline === false ?
                <input
                    type={type}
                    value={value}
                    min="0"
                    defaultValue={defaultValue}

                    placeholder={placeholder}
                    style={{
                        ...styles.infoEditSmallTextInput,
                        height: height,
                        width: width,
                        backgroundColor: inputBackgroundColor,
                        fontFamily: "Onest",
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: 16,
                        ...style
                    }}
                    onChange={memoizedOnChange}

                />
                :
                <textarea
                    value={value || ""}
                    placeholder={placeholder}
                    style={{
                        ...styles.infoEditSmallTextInput,
                        width: width,
                        height: height,
                        resize: "none",
                        backgroundColor: inputBackgroundColor,
                        fontFamily: "Onest",
                        padding: 15,
                        fontSize: 16,
                        ...style
                    }}
                    onChange={memoizedOnChange}
                />
            }
        </div>
    )
}


const LevelSelectorButtons = ({ onChange }) => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const isCompactMobile = screenWidth < 768 && screenWidth <= screenHeight;
    const mobileInnerWidth = Math.min(290, screenWidth - 70);
    //const englishLevels = ["Pre-k", "Beginner", "Elementary", "Pre-intermediate", "Intermediate", "Upper-intermediate", "Advanced"];
    const student = useSelector(state => state.student);
    const dispatch = useDispatch();
    const [selectedLevel, setSelectedLevel] = useState(student.englishLevel);

    const handleLevelChange = useCallback((level) => {


        setSelectedLevel(level);
        if (typeof onChange === "function") {
            onChange(level);
        }
        dispatch(updateStudent({ englishLevel: level, lessonsProgram: [] }));
        // дописать, чтобы сразу показывала программу, если есть
    }, [dispatch, onChange]);

    useEffect(() => {
        setSelectedLevel(student.englishLevel);
    }, [student.englishLevel]);

    const levelByName = englishLevelsObjectArray.reduce((acc, level) => {
        acc[level.name] = level;
        return acc;
    }, {});

    const mobileLevelRows = [
        ["Trials"],
        ["Pre-k", "Juniors", "Starters"],
        ["World Talkers", "Chat Masters"],
        ["Movers", "Flyers"],
    ]
        .map((row) => row.map((name) => levelByName[name]).filter(Boolean));

    return (
        <div style={{ ...styles.infoEditContainer }}>
            <OnestBoldSmall>{t("Программа")}</OnestBoldSmall>
            <div style={{
                ...styles.levelSelectorContainer,
                width: screenWidth > 1155 ? 420 : isCompactMobile ? mobileInnerWidth : "100%",
                gap: isCompactMobile ? 5 : 10,
            }}>
                {isCompactMobile ? (
                    mobileLevelRows.map((row, rowIndex) => (
                        <div
                            key={`mobile-level-row-${rowIndex}`}
                            style={{ display: "flex", width: "100%", gap: 10 }}
                        >
                            {row.map((el) => {
                                const shouldStretch = row.length === 2 || row.length === 3;
                                return (
                                    <div
                                        key={el.index}
                                        style={shouldStretch ? { flex: 1 } : undefined}
                                    >
                                        <label
                                            style={{
                                                ...styles.levelSelectorButton,
                                                ...(String(selectedLevel) === String(el?.index) && styles.levelSelectorButtonActive),
                                                width: shouldStretch ? "100%" : "auto",
                                                justifyContent: shouldStretch ? "center" : "flex-start",
                                                boxSizing: "border-box",
                                                minWidth: 0,
                                            }}
                                            onClick={() => handleLevelChange(el.index)}
                                        >
                                            <OnestNormalSmall>{el.name}</OnestNormalSmall>
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    ))
                ) : (
                    englishLevelsObjectArray.map(el => (
                        <div key={el.index}>
                            <label
                                style={{
                                    ...styles.levelSelectorButton,
                                    ...(String(selectedLevel) === String(el?.index) && styles.levelSelectorButtonActive)
                                }}
                                onClick={() => handleLevelChange(el.index)}
                            >
                                <OnestNormalSmall>{el.name}</OnestNormalSmall>
                            </label>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export const StudentProfileInfoEdit = ({ levels, image, addCashImage }) => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const isCompactMobile = screenWidth < 768 && screenWidth <= screenHeight;
    const mobileInnerWidth = Math.min(290, screenWidth - 70);

    const student = useSelector(state => state.student);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();


    const [name, setName] = useState(student.name || "");
    const [age, setAge] = useState(student.age || 7);
    const [additionalInfo, setAdditionalInfo] = useState(student.additionalInfo || "");
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [isShowModalSimple, setIsShowModalSimple] = useState(false);
    const [modalType, setModalType] = useState("none");
    const [modalH2, setModalH2] = useState("");
    const [modalP, setModalP] = useState("");
    const [isShowModalQuestion, setIsShowModalQuestion] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(null);
    const shouldShowModalRef = useRef(false);
    const pendingPathRef = useRef(null);
    const isNavigationAllowedRef = useRef(false);

    /* 
        useEffect(() => {
            setName(student.name || "");
            setAge(student.age || 7);
            setAdditionalInfo(student.additionalInfo || "");
            setIsSaveButtonDisabled(true);
        }, [student.name, student.age, student.additionalInfo]);
     */

    async function studentDataUpdateSubmit(e) {
        e.preventDefault()
        setIsLoading(true)
        setIsSaveButtonDisabled(true)
        if (student.studentId === -1) {
            console.warn('image ', image)
            axios.post(config.BACKEND_ADDR + "/students/", {
                name: name,
                age: parseInt(age),
                english_skill: '' + student.englishLevel,
                comment: additionalInfo
            }).then(res => {
                if (image) {
                    axios.patch(config.BACKEND_ADDR + "/students/", {
                        student_id: res.data.id,
                        image: image
                    }).then(() => {

                        addCashImage('');
                        navigate(`/service/students/${res.data.id}`);
                        window.location.reload();
                    }).catch((err) => {
                        console.log(err);
                        alert(t("Ошибка загрузки фото ученика"));
                    })
                } else {
                    addCashImage('');
                    navigate(`/service/students/${res.data.id}`);
                    setIsLoading(false)
                    window.location.reload();
                }
                navigate(`/service/students/${res.data.id}`)
                window.location.reload();
            }).catch((err) => {
                console.error(err)
                if (err?.response?.data?.includes("Превышен лимит")) {
                    setModalH2(t("На одном аккаунте может быть не более 30 учеников одновременно"));
                    setModalP(t("Чтобы добавить нового ученика, удалите из журнала тех, с кем вы больше не занимаетесь"));
                    setIsShowModalSimple(true);
                } else {
                    setModalH2(t("Ошибка добавления ученика"));
                    setModalP(err.response?.data || "");
                    setIsShowModalSimple(true);
                }
            })
            return
        }

        const responseProgram = await axios.put(config.BACKEND_ADDR + "/program/", {
            student_id: student.studentId,
            level_name: student.englishLevel,
        });

        let newData = responseProgram.data.map(step => {
            const createdAt = moment(step.created_at).valueOf();
            const updatedAt = moment(step.updated_at).valueOf();
            const deletedAt = step.deleted_at ? moment(step.deleted_at).valueOf() : null;
            return {
                ...step,
                created_at: createdAt,
                updated_at: updatedAt,
                deleted_at: deletedAt
            };
        });

        dispatch(updateStudent({
            lessonsProgram: newData
        }));

        axios.patch(config.BACKEND_ADDR + "/students/", {
            student_id: student.studentId,
            name: name,
            age: parseInt(age),
            english_skill: '' + student.englishLevel,
            comment: additionalInfo,
            teacher_id: user.id,
            balance: student.balance
        }).then(() => {
            dispatch(updateStudent({
                studentId: student.studentId,
                name: name,
                age: parseInt(age),
                englishLevel: student.englishLevel,
                additionalInfo: additionalInfo,
                balance: student.balance
            }))

        }).catch((err) => {
            console.log(err)
            alert(t("Ошибка обновления данных ученика"))
        }).finally(() => {
            setIsLoading(false)
            setIsSaveButtonDisabled(true)
        })
    }

    // Обработчик события покидания страницы
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (!isSaveButtonDisabled) {
                e.preventDefault();
                e.returnValue = ""; // Показывает стандартное предупреждение браузера
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isSaveButtonDisabled]);

    // Обработчик для предупреждения при навигации внутри приложения
    useEffect(() => {
        const handleRouteChange = (e) => {
            if (!isSaveButtonDisabled) {
                setPendingNavigation(() => {
                    // Разрешаем переход - браузер сам обработает popstate
                    window.history.back();
                });
                setIsShowModalQuestion(true);
                e.preventDefault();
            }
        };

        window.addEventListener("popstate", handleRouteChange);

        return () => {
            window.removeEventListener("popstate", handleRouteChange);
        };
    }, [isSaveButtonDisabled]);

    useBlocker(({ currentLocation, nextLocation }) => {
        // Если навигация явно разрешена пользователем и путь совпадает с сохраненным, не блокируем
        if (isNavigationAllowedRef.current && pendingPathRef.current === nextLocation.pathname) {
            isNavigationAllowedRef.current = false;
            return false;
        }
        // Если модалка уже открыта, продолжаем блокировать
        if (isShowModalQuestion) {
            return true;
        }
        // Если флаг установлен, но модалка еще не открыта, продолжаем блокировать
        if (shouldShowModalRef.current) {
            return true;
        }
        if (!isSaveButtonDisabled) {
            // Сохраняем путь
            const targetPath = nextLocation.pathname;
            pendingPathRef.current = targetPath;
            // Устанавливаем флаг перед асинхронным вызовом
            shouldShowModalRef.current = true;
            // Используем queueMicrotask для асинхронного вызова setState
            queueMicrotask(() => {
                if (shouldShowModalRef.current) {
                    setPendingNavigation(() => {
                        // Разрешаем переход через роутер
                        navigate(targetPath);
            });
                    setIsShowModalQuestion(true);
                }
            });
            return true; // Блокируем переход
        }
        return false;
    });

    const handleChangeName = (e) => {
        setName(e.target.value)
        let isFormIncomplete = false;
        if (e.target.value.length === 0 || !(age > 0)) {
            isFormIncomplete = true;
        }
        console.warn('isFormIncomplete', isFormIncomplete)
        setIsSaveButtonDisabled(isFormIncomplete);
    }

    const handleChangeAge = (e) => {
        setAge(e.target.value)
        let isFormIncomplete = false;
        if (name.length === 0 || !e.target.value) {
            isFormIncomplete = true;
        }
        console.warn('isFormIncomplete', isFormIncomplete)
        setIsSaveButtonDisabled(isFormIncomplete);
    }

    const handleChangeLevel = (level) => {
        let isFormIncomplete = false;
        if (name.length === 0 || age === 0) {

            isFormIncomplete = true;
        }
        console.warn('isFormIncomplete', isFormIncomplete, name, name.length, age === 0)
        setIsSaveButtonDisabled(isFormIncomplete);
    }

    const handleChangeAdditionalInfo = (e) => {
        setAdditionalInfo(e.target.value)
        let isFormIncomplete = false;
        if (name.length === 0 || !(age > 0)) {
            isFormIncomplete = true;
        }
        console.warn('isFormIncomplete', isFormIncomplete)
        setIsSaveButtonDisabled(isFormIncomplete);
    }

    const handleModalQuestionClose = useCallback((answer) => {
        setIsShowModalQuestion(false);
        shouldShowModalRef.current = false;
        if (answer) {
            // Пользователь выбрал "Остаться" - ничего не делаем
            setPendingNavigation(null);
            pendingPathRef.current = null;
        } else if (pendingPathRef.current) {
            // Пользователь выбрал "Уйти" - разрешаем переход
            // Сохраняем путь перед установкой флага (НЕ очищаем pendingPathRef сразу!)
            const targetPath = pendingPathRef.current;
            // Устанавливаем флаг разрешения навигации
            isNavigationAllowedRef.current = true;
            // Очищаем состояние перед навигацией
            setPendingNavigation(null);
            // Вызываем navigate напрямую - useBlocker проверит флаг и путь
            navigate(targetPath);
            // Очищаем путь после навигации
            setTimeout(() => {
                pendingPathRef.current = null;
            }, 100);
        }
    }, [navigate]);

    return (
        <React.Fragment>
            <ModalQuestion
                isOpen={isShowModalQuestion}
                onClose={handleModalQuestionClose}
                type="question"
                h2={t("Хотите остаться на странице?")}
                p={t("У вас есть несохраненные изменения.")}
                yesText={t("Остаться")}
                noText={t("Уйти")}
                isButtonRevers={true}
            />
            <ModalSimple
                isOpen={isShowModalSimple}
                onClose={() => setIsShowModalSimple(false)}
                type={modalType}
                h2={modalH2}
                p={modalP}
            />
            <form
                style={{
                    ...styles.infoEditForm,
                    width: screenWidth > 1155 ? 420 : isCompactMobile ? mobileInnerWidth : "100%",
                }}
                onSubmit={studentDataUpdateSubmit}
            >
                <div style={{ display: "flex", flexDirection: screenWidth > 550 ? "row" : "column", gap: 10 }}>
                    <TextInput

                        title={t("Имя и фамилия")}
                        value={name}
                        onChange={handleChangeName}
                        inputBackgroundColor={color_grey_ultra_light}
                        style={{
                            borderWight: 1,
                            borderColor: name.length ? color_grey_ultra_light : color_red_active,
                        }}
                    />
                    <TextInput

                        title={t("Возраст")}
                        type="number"
                        value={age}
                        onChange={handleChangeAge}
                        inputBackgroundColor={color_grey_ultra_light}
                        style={{
                            borderWight: 1,
                            borderColor: age > 0 ? color_grey_ultra_light : color_red_active,
                        }}
                    />
                </div>
                <LevelSelectorButtons
                    onChange={handleChangeLevel}
                    defaultValue={student.englishLevel} />
                <TextInput
                    multiline={true}
                    height={128}
                    title={t("Дополнительная информация")}
                    value={additionalInfo}
                    onChange={handleChangeAdditionalInfo}
                    inputBackgroundColor={color_grey_ultra_light}
                />
                <div
                    style={{
                        marginTop: 25,
                        display: "flex",
                        justifyContent: screenWidth > 1155 ? "flex-end" : "center",
                        alignItems: "center",
                        gap: 16,
                    }}>
                    {isLoading && <OnestNormalDefault style={{ marginLeft: "16px", marginRight: "16px" }} >{t("Сохранение...")}</OnestNormalDefault>}
                    {isLoading &&
                        <ClipLoader
                            color={color_red_default}
                            size={35}
                            loading={isLoading}
                        />
                    }
                    <Button
                        width={screenWidth > 1155 ? 145 : (isCompactMobile ? mobileInnerWidth : "100%")}
                        height={40}
                        backgroundColor={isSaveButtonDisabled ? color_grey_light : color_red_default}
                        color={color_white}
                        disabled={isSaveButtonDisabled}
                        type="submit"
                        style={{ marginLeft: screenWidth > 1155 ? "16px" : 0, borderWidth: 0 }}>

                        <OnestNormalDefault>{t("Сохранить")}</OnestNormalDefault>
                    </Button>
                </div>
            </form>
        </React.Fragment>
    )
}